import { render, staticRenderFns } from "./office-list.vue?vue&type=template&id=a87de6ba&"
import script from "./office-list.vue?vue&type=script&lang=js&"
export * from "./office-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports